var _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNdeIconFormatsHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XLS"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DOC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HTML"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#D1D2D3",
    strokeWidth: 1.2443,
    strokeMiterlimit: 10,
    points: "41.285,17.886 79.031,17.886  79.031,81.763 27.598,81.763 27.598,32.722  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.82,
    y: 21.833,
    fill: "#29ABE2",
    width: 54.13,
    height: 21.776
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#1D76BB",
    points: "19.82,43.609 26.984,43.609 26.984,50.716  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.216,26.315h2.719v12.176h-2.719V33.7h-4.842v4.791h-2.717V26.315h2.717v5.086h4.842V26.315z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M41.392,28.666v9.825h-2.72v-9.825h-3.448v-2.351h9.617v2.351H41.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57.731,30.825l-3.292,6.656h-1.62l-3.275-6.656v7.666h-2.718V26.315h3.675l3.137,6.688l3.153-6.688 h3.657v12.176h-2.717V30.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M62.748,38.491V26.315h2.718v9.755h5.192v2.421H62.748z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#E7E7E7",
    strokeWidth: 2.2003,
    strokeMiterlimit: 10,
    cx: 53.314,
    cy: 62.416,
    r: 14.782
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E7E7E7",
    strokeWidth: 2.2003,
    strokeMiterlimit: 10,
    x1: 38.532,
    y1: 62.41,
    x2: 68.096,
    y2: 62.421
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E7E7E7",
    strokeWidth: 2.2003,
    strokeMiterlimit: 10,
    d: "M41.323,72.169 c0,0,1.787-2.621,11.761-2.619c9.977,0.007,12.453,2.627,12.453,2.627"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E7E7E7",
    strokeWidth: 2.2003,
    strokeMiterlimit: 10,
    d: "M41.329,52.504 c0,0,1.787,2.622,11.762,2.626c9.974,0.005,12.455-2.616,12.455-2.616"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E7E7E7",
    strokeWidth: 2.2003,
    strokeMiterlimit: 10,
    d: "M53.093,47.634 c0,0-7.571,5.441-7.574,14.764c-0.003,9.326,7.563,14.834,7.563,14.834"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#E7E7E7",
    strokeWidth: 2.2003,
    strokeMiterlimit: 10,
    d: "M53.093,47.634 c0,0,7.783,5.445,7.78,14.77c-0.004,9.326-7.791,14.828-7.791,14.828"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#E7E7E7",
    strokeWidth: 2.2003,
    strokeMiterlimit: 10,
    x1: 53.093,
    y1: 47.634,
    x2: 53.082,
    y2: 76.925
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M69.167,74.991c0,1.287-1.044,2.33-2.333,2.33h-5.63c-1.286,0-2.33-1.043-2.33-2.33v-3.302 c0-1.288,1.044-2.331,2.33-2.331h5.63c1.289,0,2.333,1.043,2.333,2.331V74.991z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M61.204,75.177c0,0.644-0.52,1.164-1.165,1.164l0,0c-0.644,0-1.165-0.521-1.165-1.164V61.39 c0-0.645,0.521-1.166,1.165-1.166l0,0c0.646,0,1.165,0.521,1.165,1.166V75.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M63.858,75.177c0,0.644-0.521,1.164-1.166,1.164l0,0c-0.644,0-1.164-0.521-1.164-1.164v-9.298 c0-0.642,0.521-1.164,1.164-1.164l0,0c0.645,0,1.166,0.522,1.166,1.164V75.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M66.514,75.177c0,0.644-0.522,1.164-1.167,1.164l0,0c-0.643,0-1.165-0.521-1.165-1.164v-9.298 c0-0.642,0.522-1.164,1.165-1.164l0,0c0.645,0,1.167,0.522,1.167,1.164V75.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M62.18,75.231c0.335,0.572,0.089,1.34-0.551,1.716c0,0-1.804,0.188-2.142-0.385l-3.793-5.464 c-0.336-0.573-0.09-1.343,0.551-1.716l0,0c0.637-0.374,1.43-0.213,1.766,0.359L62.18,75.231z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M69.167,75.177c0,0.644-0.521,1.164-1.166,1.164l0,0c-0.644,0-1.167-0.521-1.167-1.164v-9.298 c0-0.642,0.523-1.164,1.167-1.164l0,0c0.645,0,1.166,0.522,1.166,1.164V75.177z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "CSV"
  }), /*#__PURE__*/React.createElement("g", {
    id: "JSON"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdeIconFormatsHtml);
export default __webpack_public_path__ + "static/media/NDE_icon_formats_html.3482ac6b.svg";
export { ForwardRef as ReactComponent };